import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../../components/Utils/CallApi";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { setError } from "../appSlice";

export const fetchSeoContent = createAsyncThunk(
  "seo/fetchSeoContent",
  async (companyId, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = "type=SEO&companyId=" + companyId;
      const response = await get("content/get", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const saveSeoContent = createAsyncThunk(
  "seo/saveSeoContent",
  async (
    { allSeoData, sectionId },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const payload = {
        type: "SEO",
        data: allSeoData.data,
      };

      dispatch(setPageLoadingTrue());
      const state = getState();
      const response = await post(
        "content/save",
        payload,
        state.app,
        sectionId
      );

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.data;
    } catch (error) {
      dispatch(setError("An error has occurred"));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const addSeoContent = (content) => ({
  type: "seo/addSeoContent",
  payload: content,
});

export const editSeoContent = (updatedContent) => ({
  type: "seo/editSeoContent",
  payload: updatedContent,
});

const seoSlice = createSlice({
  name: "seo",
  initialState: {
    seoContent: [],
    loading: false,
    error: null,
  },
  reducers: {
    addSeoContent: (state, action) => {
      if (action.payload) {
        state.seoContent.push(action.payload);
      }
    },
    editSeoContent: (state, action) => {
      const index = state.seoContent.findIndex(
        (content) => content.id === action.payload.id
      );
      if (index !== -1) {
        state.seoContent[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSeoContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSeoContent.fulfilled, (state, action) => {
        state.loading = false;
        state.seoContent = action.payload;
      })
      .addCase(fetchSeoContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveSeoContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveSeoContent.fulfilled, (state, action) => {
        state.loading = false;
        state.seoContent.push(action.payload);
      })
      .addCase(saveSeoContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default seoSlice.reducer;
